import React from 'react';
import { IIconProps, sizeMap } from './types';

export const MenuIcon = ({ className, size = 'medium' }: IIconProps) => (
  <svg
    className={className}
    width={sizeMap[size].width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 12.5946V9.02703M11.5 9.02703C12.9569 9.02703 14.1379 7.69598 14.1379 6.05405H8.86207C8.86207 7.69598 10.0431 9.02703 11.5 9.02703ZM7.98276 2.48649L4.46552 6.05405M18.8276 17.9459L15.3103 21.5135M16.1897 20.6216H5.34483V5.16216M17.6552 19.1351V3.37838H7.10345M9.74138 12.5946H13.2586M7.98276 14.973H15.1638M9.44828 16.7568H13.5517M3 1V23H20V1H3Z"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MenuIcon;
